// @flow
import styled from 'styled-components';
import { errorText, se300 } from '../../colors';
import DefaultTheme from '.';
/*::
  import type { TextAreaThemeType } from '.';
*/

var theme
/*: TextAreaThemeType */
= Object.assign({}, DefaultTheme, {
  TextArea: styled(DefaultTheme.TextArea).withConfig({
    displayName: "shipa-ecommerce__TextArea",
    componentId: "sc-1yzicr6-0"
  })(["&:focus{border-bottom:1px solid ", ";}"], function (pr) {
    return pr.error ? errorText() : se300();
  })
});
export default theme;